module.exports = __webpack_public_path__ + "img/location-confirm.21925812.jpg";